// extracted by mini-css-extract-plugin
export default {"commit-discussion-comments":"Comment-module__commit-discussion-comments--GlkCu","discussion-comments-rose":"Comment-module__discussion-comments-rose--JwtpK"};